var _path, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "#2c3e50",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 9,
    x2: 19,
    y2: 9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 15,
    x2: 19,
    y2: 15
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 4,
    x2: 7,
    y2: 20
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 13,
    y2: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.3e43ce5c.svg";
export { ForwardRef as ReactComponent };